import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle} from 'react'


import {useStatusrequest} from '../../contextProviders/Atomqueryprovider'

import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import { useSelectStyles } from '../../helpers/useSelectStyles'
type Props = {
 
  show: boolean
  handleClose: () => void
  ref: any
}
const uuidTime = () => {
  return new Date().valueOf()
}

const CURRENCY_APP = process.env.REACT_APP_CURRENCY



const initialValues = {
  request_transactionid: '',
}

const productSchema = Yup.object().shape({
  request_transactionid: Yup.string().required('The transaction ID is required'),

})
export const Mpesatransactionquery: FC<Props> = forwardRef((props, ref) => {
 
  const [requestdata, setRequestdata] = useState<any>({})

  const [loading, setLoading] = useState(false)
  const [submittingready, setSubmittingready] = useState<boolean>(false)
  //customer id and payment type


  
const {mutateAsync: paymentrequestmutateAsync} = useStatusrequest(
  requestdata
)


  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      setLoading(true)
 
      setRequestdata({
        request_transactionid: values.request_transactionid
        
      })

      setSubmittingready(true)
    },
  })


 
  useEffect(() => {
    if (submittingready && requestdata) {

      
      paymentrequestmutateAsync(requestdata, {
        onSuccess: () => {
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setRequestdata({})
          setSubmittingready(false)
          props.handleClose()
        },
        onError(error, variables, context) {
          formik.setStatus('The request details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
      })
    }
  }, [submittingready])

 

  useImperativeHandle(ref, () => ({
    Resetmodalmpesavalues() {
     
      formik.resetForm({})
          formik.setSubmitting(false)
          setRequestdata({})
          setSubmittingready(false)
    }
  }))


  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Status Request</h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form 
          id='kt_modal_add_mpesastk_form'
          noValidate
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          onSubmit={formik.handleSubmit}
          >
        {/* begin::Input group */}

        <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Transaction ID</label>
                  <input
                    placeholder={"RCR2PZE8PU"}
                   
                    {...formik.getFieldProps('request_transactionid')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.request_transactionid && formik.errors.request_transactionid,
                      },
                      {
                        'is-valid':
                          formik.touched.request_transactionid && !formik.errors.request_transactionid,
                      }
                    )}
                  />
                  {formik.touched.request_transactionid && formik.errors.request_transactionid && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.request_transactionid}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              
            </div>

            {/* end::Input group */}

           
              
          </form>
        </div>

        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_mpesastk_form'
            className='btn btn-success'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Check Status</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
